import React from 'react'
import StaticMap from '../../atoms/StaticMap'
import { Center } from '@/types/models'
import { getGeoLoc, getFeaturedImage } from '@/domain/center'
const STYLES =
  'aspect-[16/6] max-h-[150px] w-full rounded-t-xl object-cover md:aspect-[4/3] md:size-full max-h-full md:rounded-xl md:rounded-r-none'

const MAP_ZOOM = 13
const MAP_DESKTOP_WIDTH = 308
const MAP_DESKTOP_HEIGHT = 241
const MAP_MOBILE_WIDTH = 400
const MAP_MOBILE_HEIGHT = 150
const MAP_STYLES = 'cm074wkdx00pc01o08yt3ftd3'
type Props = {
  center: Center
}

/**
 * StandardProfileFeatureImage component
 *
 * This component displays a featured image for a center if available.
 * If the featured image is not present, it falls back to displaying a static map
 * showing the center's location.
 *
 * @prop  {Center} center - The center object
 * @return {JSX.Element} - profile card image
 */
const StandardProfileFeatureImage = ({ center }: Props): JSX.Element => {
  const showCenterFeaturedImage = !!getFeaturedImage(center)

  if (showCenterFeaturedImage) {
    const centerFeaturedImage = getFeaturedImage(center).split('/').pop()
    return (
      <picture>
        <source
          srcSet={`https://res.cloudinary.com/rehabpath/image/upload/e_gen_restore/c_fill,w_640,h_240,q_15/f_auto/${centerFeaturedImage}`}
          media="(max-width: 767px)"
        />
        <img
          className={STYLES}
          loading="lazy"
          src={`https://res.cloudinary.com/rehabpath/image/upload/e_gen_restore/c_fill,w_640,h_480,q_15/f_auto/${centerFeaturedImage}`}
        />
      </picture>
    )
  }

  const centerLocation = getGeoLoc(center)

  return (
    <>
      <StaticMap
        className={`${STYLES} md:hidden`}
        lng={centerLocation.lng}
        lat={centerLocation.lat}
        zoom={MAP_ZOOM}
        width={MAP_MOBILE_WIDTH}
        height={MAP_MOBILE_HEIGHT}
        mapStyles={MAP_STYLES}
      />
      <StaticMap
        className={`${STYLES} hidden md:block`}
        lng={centerLocation.lng}
        lat={centerLocation.lat}
        zoom={MAP_ZOOM}
        width={MAP_DESKTOP_WIDTH}
        height={MAP_DESKTOP_HEIGHT}
        mapStyles={MAP_STYLES}
      />
    </>
  )
}

export default StandardProfileFeatureImage
